import { Grid } from "@mui/material";
import { useSegments } from "api/segments";
import { RequiredFieldLabel } from "components/FormControls/RequiredFieldLabel";
import { SelectInput } from "components/FormControls/Select/Select";
import { useFormikContext } from "formik";
import { useMessage } from "hooks/intl";
import { useStyles } from "./CampaignConditions.styles";

export function ArrayCondition({ fieldName }: { fieldName: string }) {
  const classes = useStyles();
  const { message } = useMessage();
  const { setFieldValue } = useFormikContext();
  const { useSegmentsList } = useSegments();
  const { data: segmentsList } = useSegmentsList();

  return (
    <>
      <Grid item xs={6}>
        <SelectInput
          className={classes.input}
          data-test-id="condition"
          items={[
            {
              id: "not_contains",
              label: message({ id: "doesNotContain" }),
            },
            {
              id: "contains",
              label: message({ id: "contains" }),
            },
          ]}
          label={<RequiredFieldLabel text={message({ id: "condition" })} />}
          name={`${fieldName}.operator`}
          onChange={() => setFieldValue(`${fieldName}.data`, [])}
        />
      </Grid>
      <Grid item xs={6}>
        <SelectInput
          className={classes.input}
          data-test-id="condition-value"
          items={
            segmentsList?.items?.map(({ segmentId, name }) => ({
              id: segmentId,
              label: name,
            })) || []
          }
          label={<RequiredFieldLabel text={message({ id: "value" })} />}
          name={`${fieldName}.data`}
        />
      </Grid>
    </>
  );
}
